import styled from 'styled-components'
import Button from 'components/Button'

export const MapContainer = styled.div`
  height: 320px;
  margin: 0 0 0 30px;
  padding: 10px;
  border: 1px solid #C3C3C3;
  position: relative;
`

export const MapTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 10px;
  line-height: 18px;

  span{
    font-family: Plus Jakarta Sans;
    font-weight: 700;
    font-style: Bold;
    font-size: 10px;
    line-height: 18px;
  }
`

export const CustomLegend = styled.div`
  position: absolute;
  top: 80px;
  right: 10px;
  padding: 5px;
  z-index: 100;
`

export const LegendTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 10px;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  font-size: 10px;
  font-family: Plus Jakarta Sans;
  justify-content: space-between;
`

export const LegendColor = styled.div`
  width: 55px;
  height: 8px;
  margin-left: 8px;
  background-color: ${props => props.color};
`

export const HoverInfo = styled.div`
  padding: 5px 8px;
  border-radius: 4px;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  pointer-events: none;
  
  div:first-child {
    font-weight: 700;
  }
`

export const StyledViewAllBtn = styled(Button.Default)`
  .secondary_icon_container {
    flex-direction: row-reverse;
    gap: 10px;
  }
  .secondary_text_container {
    font-size: 13px;
    font-weight: 500;
    color: #000000;
  }
`